"use client";

import { useMessages } from "@/lib/i18n/useMessages";
import { Button, Stack } from "@mui/material";
import { useState } from "react";
import { SLDialogAnrufen } from "../dialogs/SLDialogAnrufen";
import { SLDialogTerminBuchen } from "../dialogs/SLDialogTerminBuchen";

export const SLButtonGroupAnrufenBuchen = ({
  size = "medium",
  isEmphasizedFreeInitialConsultation = false,
}: {
  size?: "small" | "medium";
  isEmphasizedFreeInitialConsultation?: boolean;
}) => {
  const btn = useMessages().dialogs.buttonGroup;
  const [openAnrufen, setOpenAnrufen] = useState(false);
  const [openTerminBuchen, setOpenTerminBuchen] = useState(false);

  const handleCloseAnrufen = () => {
    setOpenAnrufen(false);
  };

  const handleCloseTerminBuchen = () => {
    setOpenTerminBuchen(false);
  };

  const handleOpenAnrufen = () => {
    setOpenAnrufen(true);
  };

  const handleOpenTerminBuchen = () => {
    setOpenTerminBuchen(true);
  };

  return (
    <>
      <Stack
        direction={{ xs: "column", md: "row" }}
        gap={size === "small" ? 1 : 2}
      >
        <Button
          variant="contained"
          color="primary"
          size={size}
          onClick={handleOpenAnrufen}
        >
          {btn.callNow}
        </Button>
        {isEmphasizedFreeInitialConsultation ? (
          <Button
            variant="contained"
            color="warning"
            size={size}
            onClick={handleOpenTerminBuchen}
          >
            {btn.bookFreeInitialConsultation}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="warning"
            size={size}
            onClick={handleOpenTerminBuchen}
          >
            {btn.bookAppointment}
          </Button>
        )}
      </Stack>
      <SLDialogAnrufen handleClose={handleCloseAnrufen} open={openAnrufen} />
      <SLDialogTerminBuchen
        handleClose={handleCloseTerminBuchen}
        open={openTerminBuchen}
      />
    </>
  );
};

export default SLButtonGroupAnrufenBuchen;
